import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ChevronRight = createReactComponent("ChevronRight", ["svg", defaultAttributes, [["polyline", {
  points: "9 18 15 12 9 6",
  key: "wrg7ij"
}]]]);
export default ChevronRight;